<template>
    <guest-layout>
        <div class="verified-wrap" v-if="success">
            <img src="/assets/images/check.svg">
            <p>{{ successMessage }}</p>
            <button @click="success = !success" class="btn btn-primary main-button login-button">Oke</button>
        </div>
        <div v-else>
            <loading-block v-if="loading" />
            <div class="wrap-login" v-else>
                <h3 class="font-weight-bold text-uppercase">Lupa Password</h3>
                <div class="form-group">
                    <input type="text" v-model="form.username" v-bind:class="errors.hasOwnProperty('username') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Username atau email">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('username')">
                        {{ errors['username'][0] }}
                    </div>
                </div>
                <button type="submit" class="btn btn-primary main-button login-button" @click="handleSubmit">Reset Password</button>
                <br>
                <router-link :to="{ name: 'login' }" class="btn btn-primary main-button cancel-button">Batal</router-link>
                <div class="text-center mt-3">
                    <p>Belum memiliki akun suara.com? <br>
                        <router-link :to="{ name: 'register' }" class="font-weight-bold text-dark">Daftar Akun</router-link></p>
                </div>
            </div>
        </div>
    </guest-layout>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            errors: [],
            form: {
                username: '',
            },
            loading: false,
            success: false,
            successMessage: ''
        }
    },
    methods: {
        async handleSubmit () {
            this.loading = true;
            this.errors = [];
            await axios.post('/api/lost-password', this.form)
                .then((response) => {
                    this.loading = false;
                    this.success = true;
                    this.successMessage = response.data.message;
                })
                .catch((error) => {
                    this.loading = false;
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                });
        }
    }
}
</script>
<style>
.wrap-login {
    padding: 4%;
    margin-top: 15px;
}
</style>
